import { isEqual } from "lodash-es";

/**
 * 有的组件，比如表单容器、列表组件，其子元素是要继承上级的东西的。然而，也存在嵌套继承的情况，所以这里需要设计一个特别的逻辑
 *
 * @template T
 * @param {string} injectKey
 * @param {(...items: (T | undefined | null)[]) => T} merger  一定要做 pick，保证返回的字段不多不少！！！
 */
export const createVueInheritableContext = (injectKey, merger = (...items) => Object.assign({}, ...items)) => {
  const consumerMiddleKey = `${injectKey}:middle`;
  return {
    provider: {
      provide() {
        return {
          [injectKey]: () => consumerMiddleKey in this ? this[consumerMiddleKey] : merger(this)
        };
      }
    },
    consumer: {
      inject: {
        [injectKey]: {
          from: injectKey,
          default: null
        }
      },
      data() {
        return {
          [consumerMiddleKey]: null
        };
      },
      // mixin 进来的 created 钩子执行顺序比原来组件的靠前，但是仍然晚于 provide()
      created() {
        // 先更新 data
        this.$watch(() => merger(typeof this[injectKey] === 'function' ? this[injectKey]() : null, this.$props), (n, old) => {
          if (!isEqual(n, old)) this[consumerMiddleKey] = n;
        }, {
          immediate: true
        });

        // 由于可能存在同名的 prop 所以要暴力处理下
        Object.keys(this[consumerMiddleKey]).forEach(k => {
          Object.defineProperty(this, k, {
            enumerable: true,
            configurable: true,
            get: () => this[consumerMiddleKey][k]
          });
        });
      }
    }
  };
};
//# sourceMappingURL=vueInheritableContext.js.map
